import React, { useContext, useRef, useState } from "react";
import { MasterBannerContext } from '../../../contexts/MasterBannerContext';
import Divider from '@mui/material/Divider';
import './index.css';
import AudioComponent from './Component/index.js'


export default function ElementAudio() {
  const { master } = useContext(MasterBannerContext);

  const [collapsedAudioDiv, setCollapsedAudioDiv] = useState(true);

  const handleCollapseAudio = () => {
    setCollapsedAudioDiv(!collapsedAudioDiv)
  };
  
  return (
    <div className="mainAudio">
			<div className="audioTitleAndArrow">
				<span style={{color: '#222222', fontWeight: 'bold', fontSize: '16px', margin: '0 0 -5px 1px'}}>Audio</span>
				{collapsedAudioDiv ? 
					<img src="assets/arrownew.png" className="stepNumberArrowUp" onClick={handleCollapseAudio} style={{transform: "rotate(180deg)", padding: '5px', cursor: 'pointer', width: '11px', height: '7px', margin: '10px 0 0 0'}}/> :
					<img src="assets/arrownew.png" className="stepNumberArrowUp" onClick={handleCollapseAudio} style={{padding: '5px', cursor: 'pointer', width: '11px', height: '7px', margin: '10px 0 0 0'}}/>
        }
			</div>
			<Divider className="audioDivider"/>
      {
          !collapsedAudioDiv ? 
          <>
          <span style={{textAlign: 'center'}}>Trilha</span>
            <AudioComponent type="trilha"/>
          <span style={{textAlign: 'center'}}>IA</span>
            <AudioComponent type="IA"/>
          </>

      : <div></div> }

         
    </div>
  )
}